var map;

map = require('./map');

module.exports = function() {
  return map.call(this, function(x) {
    return !x;
  });
};
